import React from 'react';
import classes from './main.module.css';
import { Layout,} from 'antd';
import SuggestAdd from './SuggestAdd';
import Foot from './Foot';
import Top from './Top';
import ChromeAlert from './ChromeAlert';
const { Content,} = Layout;
function Main(props) {  
    return (
        <>
            <ChromeAlert/>
            <Top 
                t1={props.t1}
                t2={props.t2}
                t3={props.t3}
                t4={props.t4}
                t5={props.t5}
                t6={props.t6}
                t7={props.t7}
                t8={props.t8}
                t9={props.t9}
                n1={props.n1}
                n2={props.n2}
                n3={props.n3}
                n4={props.n4}
                n5={props.n5}
                n6={props.n6}
                n7={props.n7}
                n8={props.n8}
                n9={props.n9}
            /> 
            <Layout>                   
                <Content className={classes.mainContent}>{props.children}</Content>
                <div style={{textAlign:'right',margin:'0 30px 30px 0'}}>
                    <SuggestAdd />                            
                </div>
                <Foot/>
            </Layout>
        </>
    )

}
export default Main